var $75347037b84c1b18$exports = {};
$75347037b84c1b18$exports = {
    "rangeOverflow": (args)=>`Il valore deve essere ${args.maxValue} o precedente.`,
    "rangeReversed": `La data di inizio deve essere antecedente alla data di fine.`,
    "rangeUnderflow": (args)=>`Il valore deve essere ${args.minValue} o successivo.`,
    "unavailableDate": `Data selezionata non disponibile.`
};


export {$75347037b84c1b18$exports as default};
//# sourceMappingURL=it-IT.mjs.map
